import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		name: '物联管理中心'
	}
});

export default app;
